export const HLX_CALENDAR_EVENTS_ROUTES = {
  get: '/hlx/calendar/events',
};
